var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("contact-create")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { style: { flexGrow: 1, flexShrink: 1 } },
        [
          _c("app-contact-edit", {
            style: { flexGrow: 1, flexShrink: 1 },
            attrs: { value: _vm.contact, "drawer-button-disabled": "" },
            on: {
              input: function ($event) {
                return _vm.onContact($event)
              },
              cancel: function ($event) {
                return _vm.close()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }